export default {
  confirmDialog: {
    title: 'Are you sure?',
    confirm: 'Yes',
    abort: 'No',
    cancel: 'Cancel',
  }
}
